import { Dialog } from "../../../../../common/core-ui/Dialog.tsx";
import { useIntl } from "react-intl";
import BookStoreHours from "../common/BookStoreHours.tsx";
import { useCoursesLoaderData } from "../coursesLoader.ts";
import EmptyAssetCard from "../../../../../common/features/asset/EmptyAssetCard.tsx";
import MaterialMetaData from "../MaterialMetaData.tsx";
import styles from "./PrintReturnDialog.module.scss";
import WhiteAssetCardContainer from "../../../../../common/features/asset/WhiteAssetCardContainer.tsx";
import PrintReturnSummary from "./PrintReturnSummary.tsx";
import { Book } from "common/api/decimal/methods/course.ts";

function CourseChunk({ returns }: { returns: Book[] }) {
  return (
    <>
      {returns.map((material) => (
        <WhiteAssetCardContainer
          tagName="li"
          className={styles.whiteCard}
          key={material.id}
        >
          <EmptyAssetCard vbid={material.vbid} type="horizontal" tagName="div">
            <MaterialMetaData courseMaterial={material} size="small" />
          </EmptyAssetCard>
        </WhiteAssetCardContainer>
      ))}
    </>
  );
}

export default function PrintReturnDialog({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  const intl = useIntl();
  const { currentTerm } = useCoursesLoaderData();

  if (!currentTerm?.printInfo?.pendingReturns.length) {
    return null;
  }

  const allReturns = currentTerm.printInfo.pendingReturns.flatMap(
    (course) => course.books!
  );

  return (
    <Dialog
      onRequestClose={onRequestClose}
      title={intl.formatMessage(
        {
          defaultMessage:
            "{count, plural, one {You Need to Return your Print Book} other {You Need to Return your Print Books}}",
        },
        { count: allReturns.length }
      )}
    >
      <PrintReturnSummary printInfo={currentTerm.printInfo} />
      <BookStoreHours
        printStatus="Not Returned"
        printInfo={currentTerm.printInfo}
      />
      <ul>
        {currentTerm.printInfo.pendingReturns.map((course) => (
          <CourseChunk key={course.id} returns={course.books!} />
        ))}
      </ul>
    </Dialog>
  );
}
